import AlertModal from "../functions/AlertModal";
import Alert from "../functions/Alert";
import I18n from "../vendor/I18n";

export default class ProductChecked {

    constructor() {
        this.classSelected = "Polaris-Tabs__Tab--active";
        this.$content = null;
        this.alertModal = new AlertModal();
        this.alert = new Alert();
        this.activeRequests = [];
        this.editors = [];

        this.onChangeContent = this.onChangeContent.bind(this);
        this.onUpdatePhraseSubmit = this.onUpdatePhraseSubmit.bind(this);
        this.onPaginatorLinkClick = this.onPaginatorLinkClick.bind(this);
        this.onApproveClick = this.onApproveClick.bind(this);
        this.onReloadItemClick = this.onReloadItemClick.bind(this);
        this.onTextFormSubmit = this.onTextFormSubmit.bind(this);
        this.onTextAreaType = this.onTextAreaType.bind(this);
        this.onSortClick = this.onSortClick.bind(this);
        this.checkLastItemApproved = this.checkLastItemApproved.bind(this);
        this.onPageLimitBtnClick = this.onPageLimitBtnClick.bind(this);
        this.onUrlSaveSubmit = this.onUrlSaveSubmit.bind(this);
        this.onUrlFulltextSubmit = this.onUrlFulltextSubmit.bind(this);
        this.onUrlFulltextClear = this.onUrlFulltextClear.bind(this);
        this.reloadUrlTabWithQuery = this.reloadUrlTabWithQuery.bind(this);
        this.loadItems = this.loadItems.bind(this);
        this.abortActiveRequests = this.abortActiveRequests.bind(this);
        this.removeFromActiveRequests = this.removeFromActiveRequests.bind(this);
        this.initCkEditor = this.initCkEditor.bind(this);
        this.destroyEditors = this.destroyEditors.bind(this);
        this.synchronizeFilterHash = this.synchronizeFilterHash.bind(this);
        this.loadOneItem = this.loadOneItem.bind(this);
        this.reloadOneItem = this.reloadOneItem.bind(this);
        this.clearCacheForItem = this.clearCacheForItem.bind(this);
        this.declaineQualityImprove = this.declaineQualityImprove.bind(this);
        this.approveQualityImprove = this.approveQualityImprove.bind(this);
        this.initImprovedTooltips = this.initImprovedTooltips.bind(this);
        this.foundTermToggle = this.foundTermToggle.bind(this);
        this.collapsibleToggle = this.collapsibleToggle.bind(this);
    }

    init() {
        this.$content = $("[data-product-check-tab-content]");
        $(document).on("click", "a[data-ajax-content-selector]", this.onChangeContent);
        $(document).on("submit", "form[data-form-name=\"update-phrase-modal\"]", this.onUpdatePhraseSubmit);
        $(document).on("submit", "form[data-form-name=\"update-improved-phrase-modal\"]", this.onUpdatePhraseSubmit);
        $(document).on("click", "[data-paginator] a", this.onPaginatorLinkClick);
        $(document).on("click", "[data-list-page-limit]", this.onPageLimitBtnClick);
        $(document).on("click", "[data-approve-btn]", this.onApproveClick);
        $(document).on("click", "[data-reload-item]", this.onReloadItemClick);
        $(document).on("submit", "[data-text-form]", this.onTextFormSubmit);
        $(document).on("input", "[data-text-form] input", this.onTextAreaType);
        $(document).on("click", "[data-sort] a", this.onSortClick);
        $(document).on("click", "[data-url-save]", this.onUrlSaveSubmit);
        $(document).on("submit", "[data-url-fulltext-form]", this.onUrlFulltextSubmit);
        $(document).on("click", "[data-url-fulltext-clear]", this.onUrlFulltextClear);
        $(document).on("click", "[data-reload-item]", this.reloadOneItem);
        $(document).on("click", "[data-found-term-toggle]", this.foundTermToggle);
        $(document).on("click", "[data-improve-decline-btn]", this.declaineQualityImprove);
        $(document).on("click", "[data-improve-approve-btn]", this.approveQualityImprove);
        $(document).on("click", "[data-clear-cache]", this.clearCacheLangId);
        $(document).on("submit", "[data-form-name=\"translation-quality-form\"]", this.submitBulkModal);
        $(document).on('submit', '[data-form-name="translation-improve-approve-form"]', this.submitBulkModal);
        $(document).on('submit', '[data-form-name="product-check-approve-form"]', this.submitBulkModal);

        $(document).on("click", ".found-term-header", this.collapsibleToggle);
        $("[data-ajax-content-selector]." + this.classSelected).trigger("click");
        this.updateUrlCount();
        this.initViewRefresh();
        this.initImprovedTooltips();
    }

    initViewRefresh() {
        $(document).ready(() => {
            window.app.webSocket.bind(['translationQualityDone', 'orderQualitySended', 'productChecked'], (data) => {
                const parsed = JSON.parse(data.message);
                const jsonData = Array.isArray(parsed) ? parsed : Object.values(parsed);
                jsonData.forEach(dataItem => {
                    if (dataItem["model_lang"]) {
                        // Podpora pro ProductLang
                        if (dataItem.model_lang.indexOf("ProductLang") !== -1) {
                            const item = $("td[data-product-check-item-lang-id=\"" + dataItem.model_lang_id + "\"]");
                            this.loadOneItem("data-product-check-item", item);
                        }
                        // Podpora pro CategoryLang
                        if (dataItem.model_lang.indexOf("CategoryLang") !== -1) {
                            const item = $("td[data-category-check-item-lang-id=\"" + dataItem.model_lang_id + "\"]");
                            this.loadOneItem("data-category-check-item", item);
                        }
                    }
                })
                if (jsonData["model_lang"]) {
                    // Podpora pro ProductLang
                    if (jsonData.model_lang.indexOf("ProductLang") !== -1) {
                        const item = $("td[data-product-check-item-lang-id=\"" + jsonData.model_lang_id + "\"]");
                        this.loadOneItem("data-product-check-item", item);
                    }
                    // Podpora pro CategoryLang
                    if (jsonData.model_lang.indexOf("CategoryLang") !== -1) {
                        const item = $("td[data-category-check-item-lang-id=\"" + jsonData.model_lang_id + "\"]");
                        this.loadOneItem("data-category-check-item", item);
                    }
                }
            });
        });
    }

    clearCacheLangId(e) {
        let $this = $(e.currentTarget);
        let url = $this.data("clearCache");
        if (!url) {
            return;
        }
        $.ajax({
            url: url,
            type: "GET"
        });
    }

    updateUrlCount() {
        let href = $(".tab-count-url").data("href-url-count");
        $.ajax({
            url: href,
            type: "GET",
            success: (response) => {
                $(".tab-count-url").html(response.url_count);
            }, error: (jqXHR, textStatus, errorThrown) => {
                console.error("Error: " + errorThrown);
            }
        });
    }

    onUrlSaveSubmit(e) {
        e.preventDefault();
        let $btn = $(e.currentTarget);
        let $content = $btn.closest("[data-url-content]");
        let $elm = $content.find("[data-action]");
        let action = $elm.data("action");
        // product_langs posíláme jako JSON string v jedné POST proměnné — jQuery by pole objektů
        // rozepsal na product_langs[i][key], takže u URL použité u stovek záznamů request přeteče
        // PHP limit max_input_vars (default 1000), PHP zahodí zbytek vstupu a validace spadne na 422.
        // ($.data() vrátí rozparsované pole, u nevalidního JSONu ale původní string — posíláme ho pak beze změny.)
        let langData = $elm.data("translated-product-url-input");
        let data = {
            url: $elm.val(),
            default_url: $elm.data("default-value"),
            attribute: $elm.data("translated-product-url-attribute"),
            product_langs: typeof langData === "string" ? langData : JSON.stringify(langData || [])
        };

        $btn.attr("disabled", true).addClass("Polaris-Button--disabled");

        $.ajax({
            url: action,
            headers: {
                "X-CSRF-TOKEN": $("meta[name=\"csrf-token\"]").attr("content")
            },
            type: "POST",
            data: data,
            success: (response) => {
                if (response.status === "error") {
                    this.alertModal.show(response.message, "Error");
                } else {
                    window.alert(response.message);
                    if ($elm.data("check") === 0) {
                        $content.remove();
                    }
                }
            },
            error: (jqXHR) => {
                // HTTP chyba (422 z validace, 419, 500, timeout) se dřív nikde neprojevila
                // a uživatel čekal na uložení, které nikdy nepřišlo.
                this.alertModal.show(this.getAjaxErrorMessage(jqXHR), "Error");
            },
            complete: () => {
                $btn.removeAttr("disabled").removeClass("Polaris-Button--disabled");
            }
        });
    }

    /**
     * Vytáhne z chybové odpovědi čitelnou hlášku – nejdřív validační chyby, pak message, pak fallback.
     */
    getAjaxErrorMessage(jqXHR) {
        let response = jqXHR.responseJSON || {};
        if (response.errors) {
            let messages = [];
            Object.keys(response.errors).forEach((key) => {
                messages = messages.concat(response.errors[key]);
            });
            if (messages.length) {
                return messages.join("<br/>");
            }
        }

        return response.message || (new I18n).trans("javascript.save-url-failed");
    }

    onTextAreaType(e) {

        let $this = $(e.currentTarget ?? e);
        let $form = $this.closest("form");
        let $btn = $form.find("button[type=\"submit\"]");
        let $btnApprove = $form.find("[data-approve-btn]");
        let $checkbox = $form.find("[data-approve-lock]");
        $btn.removeAttr("disabled").removeClass("Polaris-Button--disabled");
        $btnApprove.attr("disabled", true).addClass("Polaris-Button--disabled");
        $checkbox.attr("disabled", true).addClass("Polaris-Button--disabled");

        // budu si pamatovat, které elementy byly editovány, abych je mohl na serveru ulozit - neukladam teda vsechno
        let name = $this.attr("name");
        let langElementEditedInput = $form.find("input[name=\"lang_elements_edited\"]");
        let langElementEditedInputValues = langElementEditedInput.val().split(",");
        if (!langElementEditedInputValues.includes(name)) {
            langElementEditedInputValues.push(name);
        }
        langElementEditedInput.val(langElementEditedInputValues.join(","));
    }

    onTextFormSubmit(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let langId = $this.find("input[name=\"lang_id\"]").val();

        let re = new RegExp("lang_element_.+_" + langId);
        for (let key in this.editors) {
            if (re.test(key)) {
                let dataEditor = this.editors[key].getData();
                let testareaName = key.replace(/\_\d+$/, "");
                $this.find("#" + testareaName).val(dataEditor);
            }
        }

        let data = $this.serialize();
        let url = $this.attr("action");
        $.ajax({
            url: url,
            type: "POST",
            data: data,
            success: (response) => {
                if (response.status === "error") {
                    this.alertModal.show(response.message, "Error");
                } else {
                    $this.find("[data-text-form-submit]").attr("disabled", true).addClass("Polaris-Button--disabled");
                    $this.find("[data-approve-btn]").removeAttr("disabled").removeClass("Polaris-Button--disabled");
                    $this.find("[data-approve-lock]").removeAttr("disabled").removeClass("Polaris-Button--disabled");
                    window.alert(response.msg);
                }
            }
        });
    }

    destroyEditors($form) {
        let re = new RegExp("^lang_element_.+_(\\d+)$");
        for (let key in this.editors) {
            if (re.test(key)) {
                this.editors[key].destroy();
                delete this.editors[key];
            }
        }
    }

    onReloadItemClick(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let $item = $this.closest("[data-item-card]");
        let url = $this.attr("href");

        if (url.indexOf("phrase") !== -1) { // menim z editace zpět na zobrazení
            this.destroyEditors($this.closest("form"));
        }

        $this.hide();
        $this.append("<img width=\"15\" height=\"15\" src=\"/images/ajax-loader.gif\" />");
        $.ajax({
            url: url,
            type: "GET",
            success: (response) => {
                if (response.status === "error") {
                    this.alertModal.show(response.message, "Error");
                    $this.show();
                } else {
                    $item.html(response.html);
                    initAutoheight();
                    let editors = this.initCkEditor();
                }
            }, complete: () => {
                $this.find("img").remove();
                window.tooltipStart();
                this.initImprovedTooltips();
            }
        });
    }

    initCkEditor() {
        $("[data-ckeditor-name]").each((i, el) => {
            let name = $(el).data("ckeditor-name");

            if (typeof this.editors[name] === "undefined") {

                CKEDITOR.ClassicEditor
                    .create(document.querySelector("#" + name), {
                        sourceElement: el,
                        toolbar: {
                            items: [
                                "undo", "redo",
                                "|", "heading",
                                "|", "bold", "italic",
                                "|", "link", /*'SourceEditing',*/
                                "|", "bulletedList", "numberedList", "outdent", "indent"
                            ]
                        },
                        htmlSupport: {
                            allow: [
                                {
                                    name: /.*/, // Povolit všechny názvy elementů
                                    attributes: true, // Povolit všechny atributy
                                    classes: true, // Povolit všechny třídy
                                    styles: true // Povolit všechny styly
                                }
                            ]
                        }
                    })
                    .then(editor => {
                        editor.model.document.on("change", () => {
                            this.onTextAreaType(editor.sourceElement);
                        });
                        this.editors[name] = editor;
                    })
                    .catch(error => {
                        console.error(error.stack);
                    });
            }
        });
    }

    onApproveClick(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $this.hide();
        $this.append("<img width=\"15\" height=\"15\" src=\"/images/ajax-loader.gif\" />");
        let lock = $this.closest("[data-item-card]").find("[data-approve-lock]").is(":checked");
        let url = $this.attr("href") + "?lock=" + (lock ? "1" : "0");

        $.ajax({
            url: url,
            type: "GET",
            success: (response) => {
                if (response.status === "error") {
                    this.alertModal.show(response.message, "Error");
                    $this.show();
                } else {
                    alert(response.message);
                    $this.closest("[data-item-card]").slideUp(400, (e) => {
                        let langId = $this.closest('[data-item-card]').data('productCheckItemLangId');
                        if (!langId) {
                            langId = $this.closest('[data-item-card]').data('categoryCheckItemLangId');
                        }
                        this.removeItemByLangId(langId);
                        this.checkLastItemApproved();
                        window.alert(response.message);
                    });
                }
            }, complete: () => {
                $this.find("img").remove();
            }
        });
    }

    checkLastItemApproved() {
        if ($("[data-item-card]").length === 0) {
            $("[data-ajax-content-selector]." + this.classSelected).trigger("click");
        }
    }

    onPaginatorLinkClick(e) {
        e.preventDefault();
        let href = $(e.currentTarget).attr("href");
        $("a[data-ajax-content-selector].Polaris-Tabs__Tab--active").attr("href", href);
        this.synchronizeFilterHash(href);
        $("a[data-ajax-content-selector].Polaris-Tabs__Tab--active").trigger("click");
    }

    onPageLimitBtnClick(e) {
        e.preventDefault();
        let href = $(e.currentTarget).data("href");
        href = href + (href.indexOf("?") !== false ? "&" : "?") + "limit=" + $(e.currentTarget).data("listPageLimit");
        $("a[data-ajax-content-selector].Polaris-Tabs__Tab--active").attr("href", href);
        this.synchronizeFilterHash(href);
        $("a[data-ajax-content-selector].Polaris-Tabs__Tab--active").trigger("click");
    }

    onUrlFulltextSubmit(e) {
        e.preventDefault();
        let value = $(e.currentTarget).find("[data-url-fulltext-input]").val();
        this.reloadUrlTabWithQuery(value);
    }

    onUrlFulltextClear(e) {
        e.preventDefault();
        this.reloadUrlTabWithQuery("");
    }

    reloadUrlTabWithQuery(value) {
        let $tab = $("a[data-ajax-content-selector].Polaris-Tabs__Tab--active");
        let href = $tab.attr("href");
        let url = new URL(href, window.location.origin);
        value = (value || "").trim();
        if (value !== "") {
            url.searchParams.set("url_q", value);
        } else {
            url.searchParams.delete("url_q");
        }
        url.searchParams.delete("page"); // reset stránkování při změně filtru
        let newHref = url.toString();
        $tab.attr("href", newHref);
        this.synchronizeFilterHash(newHref);
        $tab.trigger("click");
    }

    synchronizeFilterHash(url) {
        let responseUrl = new URL(url);
        let paramFilterHash = responseUrl.searchParams.get("filter_hash");
        if (url.indexOf("urls") !== -1 || url.indexOf("goods") !== -1) {
            $("a[data-ajax-content-selector=\"products\"]").each((e, elm) => {
                let $elm = $(elm);
                let from = $elm.data("fromUrl");
                let to = $elm.data("toUrl");
                let href = $elm.attr("href");
                let urlCurrent = new URL(href);
                if (paramFilterHash) {
                    urlCurrent.searchParams.set("filter_hash", paramFilterHash);
                } else {
                    urlCurrent.searchParams.delete("filter_hash");
                }
                let newUrl = urlCurrent.toString().replace(from, to);
                $elm.attr("href", newUrl);
            });

        }
    }

    onUpdatePhraseSubmit(e) {
        e.preventDefault();
        let data = $(e.currentTarget).serialize();
        $.ajax({
            url: $(e.currentTarget).attr("action"),
            type: "POST",
            data: data,
            success: (response) => {
                $(".action-modal").modal("hide");
                if (response.status === "error") {
                    this.alertModal.show(response.message, "Error");
                } else {
                    $("[data-phrase-unique-id=\"" + response.data.phraseUniqueId + "\"]").html(response.data.phrase);
                    this.clearCacheForItem($("[data-phrase-unique-id=\"" + response.data.phraseUniqueId + "\"]").closest("[data-product-check-item]"));
                    window.tooltipStart();
                    this.initImprovedTooltips();
                }
            }
        });
    }

    clearCacheForItem(item) {
        let url = item.data("product-check-item");
        if (!url || url.indexOf("item-product") === -1) {
            return; // pouze pro produkty, ktere maji cache
        }
        url = url.replace("item-product", "item-product-clear-cache");
        $.ajax({ url: url }); // jen pingneme, nic vic
    }

    onChangeContent(e) {
        e.preventDefault();
        this.abortActiveRequests();

        let $this = $(e.currentTarget);
        let $tablist = $this.closest("ul");
        let loaderDescription = $this.data("loader-description") ? $this.data("loader-description") : "";
        $(".content-loading #loader-description").text(loaderDescription);
        this.$content.html($(".content-loading").html());

        let ajaxRequest = $.ajax({
            url: $this.attr("href"),
            type: "GET",
            success: (data) => {
                this.$content.html(data.html);
                //$("[data-filter-content]").replaceWith(data.filter);
                $("[data-filtered-values]").html(data.filteredValues);
                $("[data-sort]").replaceWith(data.sort);
                this.loadItems("data-product-check-item");
                this.loadItems("data-category-check-item");
                this.loadItems("data-option-check-item");
                this.initImprovedTooltips();
            },
            error: (jqXHR, textStatus, errorThrown) => {
                this.$content.html(this.alert.danger("Chyba načtení obsahu"));
            },
            complete: () => {
                this.removeFromActiveRequests(ajaxRequest);
                $tablist.find("a").removeClass(this.classSelected);
                $this.addClass(this.classSelected);
                $(".content-loading #loader-description").text("");
            }
        });
        this.activeRequests.push(ajaxRequest);
    }

    loadItems(dataName) {
        let i = 50;
        $("[" + dataName + "]").each((index, item) => {
            $(item).html($(".content-loading").html());
            window.setTimeout(() => {
                this.loadOneItem(dataName, item);

            }, i += 50);
        });
    }

    reloadOneItem(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let dataName = $this.data("dataName");
        let item = $this.closest("[" + dataName + "]");
        this.loadOneItem(dataName, item);
    }

    foundTermToggle(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let $content = $this.closest('[data-found-term-send]');
        let $collapsible = $content.closest('.found-term-collapsible');

        if ($content.data('found-term-send') === true) {
            $content.data('found-term-send', false);
            $content.addClass('found-term-disable');
        } else {
            $content.data('found-term-send', true);
            $content.removeClass('found-term-disable');
        }

        // Update counter badge
        let count = $collapsible.find('[data-found-term-send]').filter(function () {
            return $(this).data('found-term-send') === true;
        }).length;
        $collapsible.find('.count-badge').text(count);
    }

    collapsibleToggle(e) {
        let $header = $(e.currentTarget);
        let $parent = $header.parent();
        $parent.toggleClass('active');

        let isOpened = $parent.hasClass('active');

        let $label = $header.find('.toggle-label');
        if ($label.length) {
            $label.text(isOpened ? $header.data('text-hide') : $header.data('text-show'));
        }

        // GA event tracking
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                'event': 'product_check_collapsible_click',
                'category': 'Product Check',
                'action': isOpened ? 'Open' : 'Close',
                'label': $header.data('ga-type') || 'unknown'
            });
        }
    }

    loadOneItem(dataName, item) {
        if (!dataName) return;
        let ajaxRequest = $.ajax({
            url: $(item).data(dataName.replace("data-", "")),
            type: "GET",
            success: (data) => {
                $(item).html(data.html);
            },
            complete: () => {
                this.removeFromActiveRequests(ajaxRequest);
                window.tooltipStart();
                this.initImprovedTooltips();
            }, error: (jqXHR, textStatus, errorThrown) => {
                $(item).html(this.alert.danger("Chyba načtení obsahu <a href=\"#\" data-reload-item>Zkusit znovu</a>"));
                $(item).find("a[data-reload-item]").data("dataName", dataName);
            }
        });
        this.activeRequests.push(ajaxRequest);
    }

    removeFromActiveRequests(ajaxRequest = null) {
        if (ajaxRequest) {
            let index = this.activeRequests.indexOf(ajaxRequest);
            if (index !== -1) {
                this.activeRequests.splice(index, 1);
            }
        }
    }

    abortActiveRequests() {
        this.activeRequests.forEach((request) => {
            request.abort();
        });
        this.activeRequests = [];
    }

    onSortClick(e) {
        e.preventDefault();
        $("[data-list-filter] input[name=\"sort\"]").val($(e.currentTarget).data("sortValue"));
        $("[data-list-filter]").trigger("submit");
    }

    declaineQualityImprove(e) {
        e.preventDefault();
        let url = $(e.currentTarget).attr("href");
        let item = $(e.currentTarget).closest("[data-product-check-item],[data-category-check-item]");
        // Zjistíme typ itemu
        let isProductItem = item.is("[data-product-check-item]");
        let dataName = isProductItem ? "data-product-check-item" : "data-category-check-item";

        $.ajax({
            url: url,
            type: "POST",
            success: (response) => {
                if (response.status === "error") {
                    $(item).html(this.alert.danger(response.msg + "<br/><a href=\"#\" data-reload-item>Znovu načíst</a>"));
                    $(item).find("a[data-reload-item]").data("dataName", dataName);
                } else {
                    this.loadOneItem(dataName, item);
                }
            }, error: (jqXHR, textStatus, errorThrown) => {
                $(item).html(this.alert.danger("Chyba načtení obsahu <a href=\"#\" data-reload-item>Zkusit znovu</a>"));
                $(item).find("a[data-reload-item]").data("dataName", dataName);
            }
        });
    }

    approveQualityImprove(e) {
        e.preventDefault();
        let url = $(e.currentTarget).attr("href");
        let item = $(e.currentTarget).closest("[data-product-check-item],[data-category-check-item]");
        // Zjistíme typ itemu
        let isProductItem = item.is("[data-product-check-item]");
        let dataName = isProductItem ? "data-product-check-item" : "data-category-check-item";

        let data = {};
        data.lock = item.find("input[name=\"approve-lock\"]").is(":checked") ? 1 : 0;

        data.foundTerm = [];
        item.find('[data-found-term-send]').each(function (i, el) {
            if ($(el).data('found-term-send') === true) {
                let termData = $(el).data('found-term-data');
                data.foundTerm.push(termData);
            }
        });

        $.ajax({
            url: url,
            data: data,
            type: "POST",
            success: (response) => {
                if (response.status === "error") {
                    $(item).html(this.alert.danger(response.msg + "<br/><a href=\"#\" data-reload-item>Znovu načíst</a>"));
                    $(item).find("a[data-reload-item]").data("dataName", dataName);
                } else {
                    window.alert(response.msg);
                    item.closest("[data-item-card]").slideUp(400, (e) => {
                        if (isProductItem) {
                            let langId = item.closest('[data-item-card]').data('productCheckItemLangId');
                        } else {
                            let langId = item.closest('[data-item-card]').data('categoryCheckItemLangId');
                        }
                        this.removeItemByLangId(langId);
                        this.checkLastItemApproved();
                    });
                }
            }, error: (jqXHR, textStatus, errorThrown) => {
                $(item).html(this.alert.danger("Chyba načtení obsahu <a href=\"#\" data-reload-item>Zkusit znovu</a>"));
                $(item).find("a[data-reload-item]").data("dataName", dataName);
            }
        });
    }

    cleanTableHeads(langId) {
        $('[data-table-head-lang-id="' + (langId ?? '') + '"]').remove();
        $('[data-table-separator-lang-id="' + (langId ?? '') + '"]').remove();
    }

    removeItemByLangId(langId) {

        let itm = $('[data-product-check-item-lang-id="' + langId + '"],[data-category-check-item-lang-id="'+langId+'"],[data-option-check-item-lang-id="'+langId+'"]');
        itm.find('[data-index-select-checkbox-item]').prop('checked', false).trigger('change'); // aby se odlikl pripadne zakliknuty checkbox
        itm.remove();
        this.cleanTableHeads(langId);
    }

    submitBulkModal(e) {
        e.preventDefault();

        let $form = $(e.currentTarget);
        let data = $form.serialize();
        let url = $form.attr("action");
        $.ajax({
            url: url,
            type: "POST",
            data: data,
            success: (response) => {
                if (response.status === "failed") {
                    window.app.alertModal.show(response.message, response.head);

                } else if (response.status === "error") {
                    this.alertModal.show(response.message, "Error");
                } else {
                    window.alert(response.message);
                    $form.closest(".modal").modal("hide");
                    $(document).trigger("product-checked-unselect-all");

                    if (typeof response.hideLangIds != 'undefined') {
                        response.hideLangIds.forEach((langId) => {
                            this.removeItemByLangId(langId);
                        })

                        // je to blbe, ale je dobre pockat, az server dodela joby, jinak by se stejne nacetly stejne data
                        window.setTimeout(() => {
                            this.checkLastItemApproved();
                        }, 2000);

                    }
                }
            }
        });
    }

    initImprovedTooltips() {
        // Pomocná funkce pro skrytí konkrétního tooltipu
        const hideSpecificTooltip = (phraseKey) => {
            const $phrase = $(`.improved-phrase[data-tooltip-improve-phrase="${phraseKey}"]`);
            const $tooltipContent = $(`.tooltip-improve[data-tooltip-improve-content="${phraseKey}"]`);

            $phrase.removeClass('improved-phrase--active');
            $tooltipContent.css('display', 'none');
        };

        // Funkce pro zavření všech otevřených tooltipů kromě aktuálního
        const closeAllTooltipsExcept = (excludePhraseKey) => {
            $('.improved-phrase[data-tooltip-improve-phrase]').each((index, element) => {
                const phraseKey = $(element).data('tooltip-improve-phrase');
                if (phraseKey !== excludePhraseKey) {
                    hideSpecificTooltip(phraseKey);
                }
            });
        };

        // Sledování vektoru pohybu myši
        let lastMouseY = 0;
        let mouseDirection = 'stale'; // 'up', 'down', 'stale'

        $(document).off('mousemove.improvedTooltipGlobal').on('mousemove.improvedTooltipGlobal', (e) => {
            if (e.clientY < lastMouseY - 2) {
                mouseDirection = 'up';
            } else if (e.clientY > lastMouseY + 2) {
                mouseDirection = 'down';
            }
            lastMouseY = e.clientY;
        });

        const $phrases = $('.improved-phrase[data-tooltip-improve-phrase]');

        $phrases.each((index, element) => {
            const $phrase = $(element);
            const phraseKey = $phrase.data('tooltip-improve-phrase');
            const $tooltip = $(`.tooltip-improve[data-tooltip-improve-content="${phraseKey}"]`);

            if ($tooltip.length === 0) return;

            // Čištění eventů
            $phrase.off('mouseenter.improvedTooltip mouseleave.improvedTooltip');

            $phrase.on('mouseenter.improvedTooltip', (e) => {
                closeAllTooltipsExcept(phraseKey);

                const $target = $(e.currentTarget);
                const phraseOffset = $target.offset();
                const phraseHeight = $target.outerHeight();
                const phraseWidth = $target.outerWidth();
                const scrollTop = $(window).scrollTop();
                const scrollLeft = $(window).scrollLeft();

                // Style a reset pozice tooltipu
                $tooltip.css({
                    'display': 'block',
                    'position': 'fixed',
                    'visibility': 'hidden',
                    'top': '-9999px',
                    'left': '-9999px',
                    'z-index': 99999,
                    'background': '#fff',
                    'border': '1px solid #ccc',
                    'border-radius': '4px',
                    'padding': '8px 12px',
                    'box-shadow': '0 2px 8px rgba(0,0,0,0.15)',
                    'max-width': '600px',
                    'white-space': 'normal',
                    'pointer-events': 'none'
                });

                const tooltipHeight = $tooltip.outerHeight();
                const tooltipWidth = $tooltip.outerWidth();
                const phraseTopViewport = phraseOffset.top - scrollTop;
                const phraseLeftViewport = phraseOffset.left - scrollLeft;

                // Určení strany
                let cameFromBelow = (mouseDirection === 'up');
                if (mouseDirection === 'stale') {
                    cameFromBelow = e.clientY > (phraseTopViewport + phraseHeight / 2);
                }

                const gapSize = 10;
                const windowHeight = $(window).height();

                // Výpočet dostupného místa
                const spaceAbove = phraseTopViewport - gapSize;
                const spaceBelow = windowHeight - (phraseTopViewport + phraseHeight + gapSize);

                // Rozhodnutí o směru
                let showBelow = (mouseDirection === 'down');
                if (mouseDirection === 'stale') {
                    showBelow = e.clientY < (phraseTopViewport + phraseHeight / 2);
                }

                // Automatická korekce podle místa ve viewportu
                if (showBelow && spaceBelow < tooltipHeight && spaceAbove > spaceBelow) {
                    showBelow = false;
                } else if (!showBelow && spaceAbove < tooltipHeight && spaceBelow > spaceAbove) {
                    showBelow = true;
                }

                let tooltipTop = showBelow
                    ? phraseTopViewport + phraseHeight + gapSize
                    : phraseTopViewport - tooltipHeight - gapSize;

                // Vertikální korekce proti vyjetí z obrazovky
                if (tooltipTop < 5) tooltipTop = 5;
                if (tooltipTop + tooltipHeight > windowHeight - 5) {
                    tooltipTop = windowHeight - tooltipHeight - 5;
                }

                let tooltipLeft = phraseLeftViewport + (phraseWidth / 2) - (tooltipWidth / 2);

                // Horizontální korekce
                if (tooltipLeft < 10) tooltipLeft = 10;
                if (tooltipLeft + tooltipWidth > $(window).width() - 10) {
                    tooltipLeft = $(window).width() - tooltipWidth - 10;
                }

                $target.addClass('improved-phrase--active');
                $tooltip.css({
                    'top': tooltipTop + 'px',
                    'left': tooltipLeft + 'px',
                    'visibility': 'visible',
                    'position': 'fixed'
                });
            });

            $phrase.on('mouseleave.improvedTooltip', () => {
                hideSpecificTooltip(phraseKey);
            });
        });
    }
}
